import { render, staticRenderFns } from "./AlarmInfo.vue?vue&type=template&id=0b11c54b&scoped=true"
import script from "./AlarmInfo.vue?vue&type=script&lang=js"
export * from "./AlarmInfo.vue?vue&type=script&lang=js"
import style0 from "./AlarmInfo.vue?vue&type=style&index=0&id=0b11c54b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b11c54b",
  null
  
)

export default component.exports